import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { reduce } from 'lodash';
export default function mapKeys(options) {
  return reduce(options, function (acc, curr, key) {
    var _context;
    return curr ? _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(acc), [key]) : acc;
  }, []);
}
//# sourceMappingURL=mapKeys.js.map